import React from 'react';

/**
 * SplitScreen component that renders two components side by side.
 * 
 * @param {React.Component} left - The component to render on the left side (Sidebar).
 * @param {React.Component} right - The component to render on the right side (MainContent).
 * @returns {JSX.Element} The rendered split screen layout.
 */
export const SplitScreen = ({
    left: Sidebar,
    right: MainContent,
}) => {
    return (
        <>
            <Sidebar />
            <MainContent />
        </>
    );
}